(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('live-gold-rates')) {
    class LiveGoldRates extends HTMLElement {
      connectedCallback() {
        this.onVisibility = () => {
          if (!document.hidden) this.refresh();
        };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.refresh();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      renderQuote(failed = false) {
        const label = this.querySelector('[data-gold-label]');
        if (!this.quote) {
          label.textContent = this.dataset.unavailableLabel;
          return;
        }
        const age = Date.now() - this.quote.updatedAt;
        const fresh = !failed && age < 300000;
        label.textContent = fresh ? this.dataset.liveLabel : this.dataset.latestLabel;
        const money = new Intl.NumberFormat('en-GB', {
          style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2
        });
        this.querySelector('[data-gold-22]').textContent = money.format(this.quote.perGram * 22 / 24);
        this.querySelector('[data-gold-24]').textContent = money.format(this.quote.perGram);
        const time = this.querySelector('[data-gold-time]');
        const date = new Date(this.quote.updatedAt);
        time.dateTime = date.toISOString();
        const options = { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'Europe/London', timeZoneName: 'short' };
        if (!fresh) Object.assign(options, { day: 'numeric', month: 'short' });
        time.textContent = this.dataset.updatedLabel + ' ' + new Intl.DateTimeFormat('en-GB', options).format(date);
        time.title = new Intl.DateTimeFormat('en-GB', {
          dateStyle: 'full', timeStyle: 'long', timeZone: 'Europe/London'
        }).format(date);
      }

      async refresh() {
        clearTimeout(this.timer);
        if (!this.isConnected || this.busy) return;
        if (document.hidden) {
          this.timer = setTimeout(() => this.refresh(), 60000);
          return;
        }
        this.busy = true;
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 10000);
        try {
          const response = await fetch('https://api.gold-api.com/price/XAU/GBP', {
            signal: this.controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer'
          });
          if (!response.ok) throw new Error('Gold rate unavailable');
          const data = await response.json();
          const updatedAt = Date.parse(data.updatedAt);
          if (data.symbol !== 'XAU' || data.currency !== 'GBP' ||
              typeof data.price !== 'number' || !Number.isFinite(data.price) || data.price <= 0 ||
              !Number.isFinite(updatedAt) || updatedAt > Date.now() + 60000) {
            throw new Error('Invalid gold quote');
          }
          this.quote = { perGram: data.price / 31.1034768, updatedAt };
          this.renderQuote();
        } catch {
          if (this.isConnected) this.renderQuote(true);
        } finally {
          clearTimeout(timeout);
          this.busy = false;
          if (this.isConnected) this.timer = setTimeout(() => this.refresh(), 60000);
        }
      }
    }
    customElements.define('live-gold-rates', LiveGoldRates);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj-scrap-calculator"] && !Shopify.designMode) return;
  try {
    
  import('@theme/component').then(({ Component }) => {
    if (customElements.get('mj-scrap-component')) return;
    class ScrapCalculator extends Component {
      quotes = new Map();
      requestId = 0;
      connectedCallback() {
        super.connectedCallback();
        this.life?.abort();
        this.life = new AbortController();
        this.money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
        this.clock = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' });
        this.timer = setInterval(() => { if (!document.hidden) this.loadQuote(); }, 60000);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) this.loadQuote(); }, { signal: this.life.signal });
        this.loadQuote();
      }
      updatedCallback() { super.updatedCallback(); this.loadQuote(); }
      disconnectedCallback() { super.disconnectedCallback(); clearInterval(this.timer); this.life?.abort(); this.fetchAbort?.abort(); this.requestId++; }
      changeMetal() {
        const silver = this.refs.metal.value === 'XAG';
        const options = silver ? [['800',0.8],['835',0.835],['900',0.9],['925',0.925],['958',0.958],['999',0.999]] : [['9ct · 375',0.375],['14ct · 585',0.585],['18ct · 750',0.75],['21ct · 875',0.875],['22ct · 916',22/24],['24ct · 999',0.999]];
        this.refs.purity.replaceChildren(...options.map(([label,value]) => new Option(label,String(value),false,value === (silver ? 0.925 : 22/24))));
        this.loadQuote();
      }
      async loadQuote() {
        const symbol = this.refs.metal.value;
        const id = ++this.requestId;
        this.fetchAbort?.abort();
        const cached = this.quotes.get(symbol);
        if (cached && Date.now() - cached.fetched < 30000) { this.calculate(); return; }
        const controller = new AbortController();
        this.fetchAbort = controller;
        const timeout = setTimeout(() => controller.abort(),10000);
        this.refs.total.textContent = '—';
        this.refs.rate.textContent = this.dataset.loading;
        this.refs.timestamp.textContent = '';
        try {
          const response = await fetch('https://api.gold-api.com/price/' + symbol + '/GBP', { signal:controller.signal,credentials:'omit',referrerPolicy:'no-referrer' });
          if (!response.ok) throw new Error('Quote unavailable');
          const quote = await response.json();
          const updated = Date.parse(quote.updatedAt);
          if (quote.currency !== 'GBP' || quote.symbol !== symbol || !Number.isFinite(quote.price) || quote.price <= 0 || !Number.isFinite(updated) || updated > Date.now() + 60000 || Date.now() - updated > 345600000) throw new Error('Invalid quote');
          if (id !== this.requestId || !this.isConnected) return;
          this.quotes.set(symbol,{price:quote.price / 31.1034768,updated,fetched:Date.now()});
          this.calculate();
        } catch {
          if (id !== this.requestId || !this.isConnected) return;
          this.quotes.delete(symbol);
          this.refs.total.textContent = '—';
          this.refs.rate.textContent = this.dataset.error;
        } finally { clearTimeout(timeout); }
      }
      calculate() {
        const weight = this.refs.weight.valueAsNumber;
        const purity = Number(this.refs.purity.value);
        const valid = Number.isFinite(weight) && weight >= 0.01 && weight <= 100000;
        this.refs.weight.setAttribute('aria-invalid',String(!valid));
        if (!valid) { this.refs.total.textContent = '—'; this.refs.rate.textContent = this.dataset.invalid; return; }
        const quote = this.quotes.get(this.refs.metal.value);
        if (!quote || !Number.isFinite(purity) || purity <= 0 || purity > 1) { this.refs.total.textContent = '—'; this.refs.rate.textContent = this.dataset.error; return; }
        const rate = quote.price * purity;
        this.refs.total.textContent = this.money.format(rate * weight);
        this.refs.rate.textContent = this.money.format(rate) + ' ' + this.dataset.perGram;
        this.refs.timestamp.textContent = (Date.now() - quote.updated < 300000 ? this.dataset.live : this.dataset.latest) + ' · ' + this.clock.format(new Date(quote.updated));
      }
    }
    customElements.define('mj-scrap-component',ScrapCalculator);
  });

  } catch(e) { console.error(e); }
})();
})();
